
import "../../../global.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import TopClients from "../top-clients";
import ReusableTabs from "../reusable-tabs/reusable-tabs";

function Configurations() {
  const tabsData = [
    { label: "Top Survey", value: "survey", component: <TopClients /> },
    { label: "Top Client", value: "client", component: <TopClients /> },
    { label: "Top Supplier", value: "supplier", component: <TopClients /> },
  ];
  return (
    <>
      <ReusableTabs tabs={tabsData} />
    </>
  );
}
export default Configurations;
